
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getAll(pageUrl=null) {
        const user = JSON.parse(localStorage.getItem('user'));
    
        let url = `${API_URL}/production-user?page=${pageUrl}`;
    
        // Si el usuario tiene un role 3, agregar el user_id a la URL
        if(user && user.role === '3'){
            url += `&user_id=${user.id}`;
        }
    
        return axios.get(url, { headers: authHeader() });
    },
    getData(id) {
        return axios.get(`${API_URL}/production-user/${id}`, { headers: authHeader() });
    },
    createData(data) {
        return axios.post(`${API_URL}/production-user`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/production-user/${id}`, data, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/production-user/${id}`, { headers: authHeader() });
    },
   
};